export const LinkStyle = { color: "inherit", textDecoration: "inherit" };

export const NavStyle = {
  backgroundColor: "rgb(13, 31, 24)",
  color: "#FFFFFF",
  boxShadow: "none",
  padding: "0.3rem 1rem",
  borderColor: "rgb(13, 31, 24)",
  zIndex: "5" 
};